import React, { useState } from 'react'
import { IconButton, Typography } from '@mui/material'
import InfoNotificationBlue from '../images/notificationInfoBlue'
import PriceChangesPopOver from './PriceChangesPopOver'
import { pdsAnalytics } from 'analytics/pdsAnalytics'
import PropTypes from 'prop-types'
import { IS_NEW_LAYOUT_ENABLED } from 'constants/layoutConstant'

const PriceChangesInfo = ({ popOverData, transformOrigin, isTotalPopOver }) => {
    const [totalPriceChangeAnchor, setTotalPriceChangeAnchor] = useState(null)

    const eventValues = {
        linkType: 'modal:tool tip',
        contentSubType: 'pds modal',
        sateliteTrackId: 'moduleToolTipClick'
    }

    let oldPadding = isTotalPopOver ? '0px 8px 6px' : '0px 8px 7px'
    let newPadding = isTotalPopOver ? '0px 0px' : '0px 5px'

    const handleTotalChangeAction = (event) => {
        pdsAnalytics.clickEvent(popOverData.title, eventValues)
        setTotalPriceChangeAnchor(event.currentTarget)
    }

    const handleClose = () => {
        setTotalPriceChangeAnchor(null)
    }

    return (
        <>
            <Typography component="span">
                <IconButton
                    aria-label={`${popOverData.title} info`}
                    onClick={handleTotalChangeAction}
                    cursor="pointer"
                    tabIndex={0}
                    sx={{
                        padding: IS_NEW_LAYOUT_ENABLED ? newPadding : oldPadding,
                        mt: IS_NEW_LAYOUT_ENABLED ? '-15px' : '0px'
                    }}
                >
                    <InfoNotificationBlue />
                </IconButton>
            </Typography>
            <PriceChangesPopOver
                popOverData={popOverData}
                priceChangeAnchor={totalPriceChangeAnchor}
                priceChangeTransformOrigin={transformOrigin}
                priceChangeAnchorClose={handleClose}
                isTotalPopOver={isTotalPopOver}
            />
        </>
    )
}

PriceChangesInfo.propTypes = {
    popOverData: PropTypes.object,
    transformOrigin: PropTypes.object,
    isTotalPopOver: PropTypes.bool
}

export default PriceChangesInfo
